import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import "./SlotCard.css";
import { useAppSelector } from "../../../store/hooks/store.hooks";
import { useDispatch } from "react-redux";
import {
  setAuthorizationModal,
  setRedirect,
} from "../../../store/models/auth/auth.slice";
import { useTranslation } from "react-i18next";
import {
  setDemo,
  setFavoriteGame,
} from "../../../store/models/slots/slot.slice";
import play from "../../../assets/icons/menu/play.svg";
import heart from "../../../assets/icons/menu/heart.svg";
import lock from "../../../assets/icons/lock.svg";
import { useMediaQuery } from "react-responsive";
import logo from "../../../assets/icons/slots_logo.svg";
interface ISlotCard {
  src: string;
  title: string;
  cardId: number;
  top: boolean;
  recs: boolean;
  new: boolean;
  live: boolean;
  disabled: boolean;
  type?: "big" | "wide";
  favorites: {
    src: string;
    title: string;
    id: number;
    top: boolean;
    recs: boolean;
    new: boolean;
    live: boolean;
    disabled: boolean;
    type?: "big" | "wide";
  }[];
}

export const SlotCard = ({
  src,
  title,
  cardId,
  top,
  recs,
  new: newGame,
  live,
  type,
  disabled,
  favorites,
}: ISlotCard) => {
  const { t } = useTranslation();
  const auth = useAppSelector((state) => state.authorization.auth);
  const [gameTitle, setGameTitle] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 599.98 });
  const slot = {
    src,
    title,
    id: cardId,
    top,
    recs,
    new: newGame,
    live,
    type,
    disabled,
  };
  return (
    <Box className={`slot-card ${type || ""} ${disabled ? "disabled" : ""}`}>
      <Box style={{ position: "relative", height: "100%" }}>
        <img
          alt={title}
          src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}/slots/${
            isMobile ? "300" : "300"
          }/${src}`}
          loading="lazy"
          onError={(e) => {
            //@ts-ignore
            e.target.src = logo;
            setGameTitle(title);
          }}
        />
        {gameTitle && <Box className="slot-card__title">{gameTitle}</Box>}
        <Box className={`hovercard`}>
          <Box className="slot-card__primary-button-container">
            <button
              disabled={disabled}
              className="slot-card__primary-button"
              onClick={(e) => {
                e.stopPropagation();
                dispatch(setDemo(false));
                if (auth) {
                  navigate(`/slots/${cardId}`);
                } else {
                  dispatch(setAuthorizationModal(true));
                  dispatch(setRedirect(`/slots/${cardId}`));
                }
              }}
            >
              <img src={play} alt="Play" />
            </button>
          </Box>
          <button
            disabled={disabled}
            className="slot-card__demo-button"
            onClick={() => {
              // debugger;
              dispatch(setDemo(true));
              navigate(`/slots/${cardId}`);
            }}
          >
            {t("slots.demo")}
          </button>
          <button
            className={`slot-card__heart-button ${
              favorites.length && favorites.find((item) => item.id === cardId)
                ? "active"
                : ""
            }`}
            onClick={() => {
              dispatch(setFavoriteGame(slot));
            }}
          >
            <img src={heart} alt="Heart" />
          </button>
        </Box>
        {disabled && (
          <Box className="slot-card__disabled">
            <Box className="slot-card__disabled-container">
              <img src={lock} alt="Lock" />
              {t("slots.lobby.card.unavailable")}
            </Box>
          </Box>
        )}
        {top ? (
          <Box className="slot-card__label top">
            {t("slots.lobby.card.top")}
          </Box>
        ) : recs ? (
          <Box className="slot-card__label recs">
            {t("slots.lobby.card.recs")}
          </Box>
        ) : newGame ? (
          <Box className="slot-card__label new">
            {t("slots.lobby.card.new")}
          </Box>
        ) : live ? (
          <Box className="slot-card__label live">
            {t("slots.lobby.card.live")}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};
